export default __webpack_public_path__ + "static/media/Homescreen-01.da6673ef.jpg";